import { FormFieldsGeneratorService } from './../customer-form/form-helpers/form-fields-generator.service';
import { ExternalInterfacesService } from './../external-interfaces/external-interfaces.service';
import { Inject, Injectable } from '@angular/core';
import { SlotsValidationService } from './slots-validation.service';
import SlotService from '../cart-process/slot.service';
import SlotModel from '../models/slot.model';
import RecaptchaService from '../customer-form/recaptcha/recaptcha.service';
import { UiHelperService } from '../utils/services/ui-helper.service';
import { DeliveryPickupService } from '../customer-form/delivery-and-payment/delivery-pickup.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../external-interfaces/notification-provider.service';
import { CommonInfoService } from '../cart-process/common-info.service';
import PageValidateModel from '../models/page-validate.model';
import { LoadersService } from '../utils/loaders/loaders.service';
import { LoaderActions } from '../utils/loaders/loader-actions.enum';
import { LeadsSupportService } from '../customer-offer/auth/leads-support.service';
import { PageValidationErrorNamesEnum } from '../models/page-validation-error-names.enum';
import { CartClearConfirmationService } from '../services/cart-clear-confirmation.service';
import { AgreementsService } from '../customer-form/agreements/agreements.service';
import { DeliveryFormStateService } from '../customer-form/form-state/delivery-form-state.service';
import { ConfigService } from '../cart-process/config.service';
import { SummaryPricesService } from '../customer-offer/summary/summary-prices.service';
declare let window: any;

@Injectable()
export class PagesValidationService {
  private msisdn: string;
  private redirectUrl: string;
  private isBundlesEmpty: boolean;

  constructor(
    @Inject('Endpoint') private endpoint: any,
    private slotsValidationService: SlotsValidationService,
    private deliveryPickupService: DeliveryPickupService,
    private recaptchaService: RecaptchaService,
    private uiService: UiHelperService,
    private notificationProviderService: NotificationProviderService,
    private slotService: SlotService,
    private commonInfo: CommonInfoService,
    private agreements: AgreementsService,
    private loadersService: LoadersService,
    private leadsService: LeadsSupportService,
    private cartClearConfirmationService: CartClearConfirmationService,
    private deliveryFormStateService: DeliveryFormStateService,
    private configService: ConfigService,
    private summaryPricesService: SummaryPricesService,
    private externalInterfacesService: ExternalInterfacesService,
    private formsGenerator: FormFieldsGeneratorService

  ) {
    this.notificationProviderService.subscribe(
      NotificationProviderTypeEnum.PAGE_VALIDATION_CART,
      this.preparePageValidationResponse.bind(this)
    );

    this.runPageValidationAfterInitPage();
  }

  public firstPageValidation(): Promise<any> {
    let resolve: any = null;
    let reject: any = null;

    const promise = new Promise((_resolve: Function, _reject: Function) => {
      resolve = _resolve;
      reject = _reject;
    });

    const slotOfferForm = this.formsGenerator.getActiveForm();

    if (slotOfferForm) {
      this.formsGenerator.checkActiveFormValidation();
    }

    setTimeout(() => {
      if (slotOfferForm && !slotOfferForm?.valid) {
        const firstInvalidControl = document.querySelectorAll('.ng-invalid.error').item(0) as HTMLElement;

        if (firstInvalidControl) this.uiService.scrollToElement(firstInvalidControl);
        reject([PageValidationErrorNamesEnum.INVALID_MNP_NUMBER]);
        return;
      } else {
        resolve();
      }
    });

    const orderValueValidation = this.checkMaxOrderValue();

    if (orderValueValidation.isValid === false) {
      reject([PageValidationErrorNamesEnum.CART_VALUE_EXCEEDED, orderValueValidation]);
    } else {
      const unfinishedSlots: SlotModel[] = this.slotService.findUnfinishedSlots();

      if (unfinishedSlots.length) {
        this.slotsValidationService.slotsValidate(unfinishedSlots);

        reject([PageValidationErrorNamesEnum.UNFINISHED_SLOTS, unfinishedSlots]);
      } else {
        resolve();
      }
    }

    return promise;
  }

  public secondPageValidation(callback: Function) {
    this.agreements.validateAllFormFields();

    const agreementsForm = this.agreements.getAgreementsForm();
    const userDataForm = this.formsGenerator.getActiveForm();
    this.formsGenerator.checkActiveFormValidation();

    setTimeout(() => {
      if ((userDataForm && !userDataForm?.valid) || !agreementsForm.valid) {
        const firstInvalidControl = document.querySelectorAll('.ng-invalid.error').item(0) as HTMLElement;

        this.uiService.scrollToElement(firstInvalidControl);
        return;
      } else {
        callback(true);
      }
    });
  }

  public thirdPageValidation(callback: Function) {
    if (!this.deliveryFormStateService.outputState.isPosAddressHidden) {
      this.deliveryPickupService.showPosError();
    }

    const paymentDeliveryForm = this.formsGenerator.getActiveForm();
    this.formsGenerator.checkActiveFormValidation();

    setTimeout(() => {
      if (!paymentDeliveryForm.valid) {
        const firstInvalidControl = document.querySelectorAll('.ng-invalid.error').item(0) as HTMLElement;

        this.uiService.scrollToElement(firstInvalidControl);
        callback(false);
        return;
      } else {
        callback(true);
      }

      callback(this.recaptchaService.validateRecaptcha());
    });
  }

  public runPageValidationAfterInitPage(): void {
    if (!this.commonInfo.isFirstPage) {
      return;
    }

    this.sendPageValidation();
  }

  private sendPageValidation(): void {
    this.loadersService.start(
      LoaderActions.MODAL_LOADER,
      {
        message: '',
        preventClose: true
      },
      true
    );

    this.endpoint('newCart.validateCart')
      .run()
      .then((pageValidateResponse: any) => {
        const response: PageValidateModel = pageValidateResponse.body;

        if (pageValidateResponse.status === 205) {
          this.externalInterfacesService.updateCartDetails();
          return;
        }

        this.notificationProviderService.publish(
          NotificationProviderTypeEnum.PAGE_VALIDATION_CART,
          new PageValidateModel(Object.assign(response, { _source: 'firstPage' }))
        );
      })
      .catch((error) => {
        if (error.status === 412 && error?.body) {
          this.notificationProviderService.publish(
            NotificationProviderTypeEnum.PAGE_VALIDATION_CART,
            new PageValidateModel(Object.assign(error.body, {_source: 'firstPage'}))
          );
        } else {
          console.error('validation error');
        }
      })
      .finally(() => {
        this.loadersService.stop(LoaderActions.MODAL_LOADER);
      });
  }

  private preparePageValidationResponse(pageValidateModel: PageValidateModel): void {

    if (!pageValidateModel) {
      return;
    }

    if (pageValidateModel.cartDetails) {
      this.msisdn = pageValidateModel.cartDetails.ssoMsisdn;
      this.redirectUrl = pageValidateModel.redirectUrl;
      this.isBundlesEmpty = !(pageValidateModel.cartDetails.bundles) || !(pageValidateModel.cartDetails.bundles).length;
    }

    if (!pageValidateModel.showLead && pageValidateModel.redirectUrl) {
      window.location.href = '/' + pageValidateModel.redirectUrl;

      return;
    }

    if (pageValidateModel.cartDetails && !pageValidateModel.showLead && this.isBundlesEmpty) {

      this.cartClearConfirmationService.clearData();

      return;
    }


    if (pageValidateModel.analyticalData) {
      this.notificationProviderService.publish(
        NotificationProviderTypeEnum.ANALYTICAL_DATA,
        pageValidateModel.analyticalData
      );
    }

    if (pageValidateModel.showLead && this.redirectUrl) {
      setTimeout(() => {
        this.leadsService.startLeads({ msisdn: this.msisdn, redirectUrl: this.redirectUrl });
      }, 1000);

      return;
    } else if (pageValidateModel.showLead && this.isBundlesEmpty) {
      setTimeout(() => {
        this.leadsService.startLeads({ msisdn: this.msisdn, clearCart: true });
      }, 1000);

      return;
    } else if (pageValidateModel.showLead && this.msisdn) {
      //TODO nie działa bez setTimeout
      setTimeout(() => {
        this.leadsService.startLeads({ msisdn: this.msisdn });
      }, 1000);
    }

    if (pageValidateModel.cartDetails) {
      this.notificationProviderService.publish(
        NotificationProviderTypeEnum.CART_DETAILS,
        pageValidateModel.cartDetails
      );
    }
  }

  private checkMaxOrderValue() {
    const summary = this.notificationProviderService.getValue(NotificationProviderTypeEnum.SUMMARY_PRICES);

    if (!summary) {
      return null;
    }

    const summaryPrices = summary.summaryPrices;
    const oneTimePaymentOrderValue = this.summaryPricesService.getDevicesAndAccessoriesPrice();
    const maxOrderValue = this.configService.maxCartValue[summaryPrices.taxName];

    return {
      isValid: (oneTimePaymentOrderValue <= maxOrderValue),
      taxName: summaryPrices.taxName,
      oneTimePaymentOrderValue,
      maxOrderValue,
    };
  }
}
